import { isNonEmptyString } from '@aloft/toolkit-shared';

/**
 * Get an attribute from an optional element, returning undefined if the attribute is an empty string
 */
export function getAttribute(element: Element | undefined, attribute: string): string | undefined {
  const attrString = element?.getAttribute(attribute);
  return isNonEmptyString(attrString) ? attrString : undefined;
}
